import React from 'react';
import ReactMarkdown from 'react-markdown';

const AdvancedMarkdownRenderer = ({ content }) => {
  return (
    <ReactMarkdown
      components={{
        a: ({ node, ...props }) => {
          const href = props.href;
          const youtubeRegex =
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})(?:\S+)?/;
          const match = href.match(youtubeRegex);

          if (match) {
            const videoId = match[1];
            return (
              <div className="video-container">
                <iframe 
                    /*width="560" 
                    height="315"*/
                    className='w-full lg:w-9 h-20rem'
                    src={`https://www.youtube.com/embed/${videoId}`} 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen>
                </iframe>
              </div>
            );
          }

          // Render other links normally
          return <a {...props} />;
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default AdvancedMarkdownRenderer;
